(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["avora-aov-images"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('avora-aov-images'))customElements.define('avora-aov-images',class extends HTMLElement{
 connectedCallback(){this.photos=new Map([...this.querySelector('template').content.querySelectorAll('[data-color]')].map(e=>[e.dataset.color,e.dataset.image]));this.draw=()=>{this.frame=0;const targets=[...document.querySelectorAll('.Avada-Bundle-Offer__Volume .Avada-VariantSelection__SelectedValue'),...document.querySelectorAll('.Avada-VariantSelection__Dropdown[aria-label="Väri"] .Avada-VariantSelection__Option')];for(const target of targets){const name=(target.querySelector('.Avada-VariantSelection__SelectedText')?.textContent||target.textContent).trim().toLowerCase();const source=this.photos.get(name);let image=target.querySelector('img.av-aov-photo');if(!source){image?.remove();continue;}if(!image){image=document.createElement('img');image.className='av-aov-photo';image.alt='';image.setAttribute('aria-hidden','true');image.width=44;image.height=44;target.prepend(image);}if(image.getAttribute('src')!==source)image.src=source;}};this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(this.draw);};this.observer=new MutationObserver(this.schedule);this.observer.observe(document.body,{childList:true,subtree:true,characterData:true});this.draw();}
 disconnectedCallback(){this.observer?.disconnect();cancelAnimationFrame(this.frame);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["avora-cart-experience"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('avora-cart-countdown')) {
  customElements.define('avora-cart-countdown', class extends HTMLElement {
    connectedCallback() {
      const validFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(this.dataset.end || '');
      this.deadline = validFormat ? Date.parse(this.dataset.end) : NaN;
      this.tick = () => {
        const seconds = Math.floor((this.deadline - Date.now()) / 1000);
        if (!Number.isFinite(seconds) || seconds <= 0) {
          this.hidden = true;
          clearInterval(this.timer);
          return;
        }
        const h = Math.floor(seconds / 3600);
        const m = Math.floor(seconds % 3600 / 60);
        const s = seconds % 60;
        this.querySelector('time').textContent = [h, m, s].map(value => String(value).padStart(2, '0')).join(':');
        this.hidden = false;
      };
      this.tick();
      if (!this.hidden) this.timer = setInterval(this.tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}

if (!customElements.get('avora-cart-discount')) {
  customElements.define('avora-cart-discount', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.querySelector('form').addEventListener('submit', event => this.apply(event), { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    async apply(event) {
      event.preventDefault();
      const drawer = this.closest('cart-drawer');
      const input = this.querySelector('input');
      const code = input.value.trim();
      const status = this.querySelector('[role="status"]');
      if (!code || this.pending || !drawer) return;
      if (drawer.dataset.avCartBusy || drawer.querySelector('.cart__items--disabled')) {
        status.textContent = this.dataset.busy;
        return;
      }
      this.pending = true;
      drawer.dataset.avCartBusy = 'true';
      drawer.setAttribute('aria-busy', 'true');
      status.textContent = '';
      const controls = [...drawer.querySelectorAll('input, select, button')].filter(node => !node.classList.contains('drawer__close'));
      const previous = controls.map(node => [node, node.disabled]);
      controls.forEach(node => { node.disabled = true; });
      const strings = { ...this.dataset };
      const wasOpen = drawer.classList.contains('active');
      try {
        const beforeResponse = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(15000) });
        if (!beforeResponse.ok) throw new Error('cart');
        const before = await beforeResponse.json();
        const previousCodes = (before.discount_codes || []).filter(item => item.applicable !== false).map(item => item.code);
        for (const item of before.items || []) {
          for (const allocation of item.line_level_discount_allocations || []) {
            if (allocation.discount_application?.type === 'discount_code') previousCodes.push(allocation.discount_application.title);
          }
        }
        for (const discount of before.cart_level_discount_applications || []) {
          if (discount.type === 'discount_code') previousCodes.push(discount.title);
        }
        const codes = [...new Map([...previousCodes, code].filter(Boolean).map(value => [value.toUpperCase(), value])).values()];
        const sectionIds = drawer.getSectionsToRender().map(section => section.id);
        const response = await fetch(this.dataset.updateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(','), sections: sectionIds, sections_url: location.pathname }),
          signal: AbortSignal.timeout(15000)
        });
        const cart = await response.json();
        if (!response.ok || cart.errors || cart.status) throw new Error('discount');
        if (!cart.sections?.['cart-drawer'] || !cart.sections?.['cart-icon-bubble']) {
          const params = new URLSearchParams({ sections: sectionIds.join(',') });
          const sectionResponse = await fetch(`${this.dataset.cartUrl}?${params}`, { signal: AbortSignal.timeout(15000) });
          if (!sectionResponse.ok) throw new Error('sections');
          cart.sections = await sectionResponse.json();
        }
        if (!cart.sections?.['cart-drawer'] || !cart.sections?.['cart-icon-bubble']) throw new Error('sections');
        const returned = (cart.discount_codes || []).find(item => item.code?.toUpperCase() === code.toUpperCase());
        const applications = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
        const applied = returned?.applicable === true || applications.some(item => item?.type === 'discount_code' && item.title?.toUpperCase() === code.toUpperCase());
        drawer.renderContents(cart, { open: wasOpen });
        const next = drawer.querySelector('avora-cart-discount');
        if (next) {
          const details = next.closest('details');
          if (details) details.open = true;
          const nextInput = next.querySelector('input');
          const nextStatus = next.querySelector('[role="status"]');
          nextInput.value = code;
          nextStatus.textContent = applied ? strings.applied : returned?.applicable === false ? strings.declined : strings.check;
          next.dataset.result = applied ? 'success' : returned?.applicable === false ? 'error' : 'pending';
          if (wasOpen) {
            if (typeof trapFocus === 'function') trapFocus(drawer.querySelector('.drawer__inner'), nextInput);
            else nextInput.focus({ preventScroll: true });
          }
        }
      } catch (error) {
        const current = drawer.querySelector('avora-cart-discount') || this;
        const message = current.querySelector('[role="status"]');
        if (message) message.textContent = strings.error;
        current.dataset.result = 'error';
      } finally {
        previous.forEach(([node, disabled]) => { if (node.isConnected) node.disabled = disabled; });
        delete drawer.dataset.avCartBusy;
        drawer.removeAttribute('aria-busy');
        this.pending = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["avora-cart-reservation-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('avora-reservation-preview')) {
  customElements.define('avora-reservation-preview', class extends HTMLElement {
    static deadlines = new Map();
    connectedCallback() {
      const duration = 10 * 60 * 1000;
      const key = `avora:reservation-preview:v1:${this.dataset.scope || '/cart'}`;
      const memory = this.constructor.deadlines;
      if (Number(this.dataset.count) <= 0) {
        memory.delete(key);
        try { sessionStorage.removeItem(key); } catch (error) {}
        this.hidden = true;
        return;
      }
      let deadline = memory.get(key);
      try {
        const stored = Number(sessionStorage.getItem(key));
        if (Number.isFinite(stored) && stored > 0) deadline = stored;
      } catch (error) {}
      if (!Number.isFinite(deadline) || deadline <= 0 || deadline > Date.now() + duration) {
        deadline = Date.now() + duration;
        try { sessionStorage.setItem(key, String(deadline)); } catch (error) {}
      }
      memory.set(key, deadline);
      this.tick = () => {
        const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
        const seconds = String(remaining % 60).padStart(2, '0');
        const output = this.querySelector('time');
        output.textContent = `${minutes}:${seconds}`;
        output.dateTime = `PT${remaining}S`;
        this.hidden = false;
        if (remaining === 0) {
          this.querySelector('[data-reservation-label]').textContent = this.dataset.expired;
          clearInterval(this.timer);
        }
      };
      this.tick();
      if (deadline > Date.now()) this.timer = setInterval(this.tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["avora-cart-upsell"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('avora-cart-upsell'))customElements.define('avora-cart-upsell',class extends HTMLElement{
 connectedCallback(){this.abort=new AbortController();const options={signal:this.abort.signal};this.addEventListener('change',event=>{if(event.target.name!=='id')return;const choice=event.target.selectedOptions[0];this.querySelector('[data-price]').textContent=choice.dataset.price;const image=this.querySelector('.av-upsell-image');image.removeAttribute('srcset');image.src=choice.dataset.image;},options);this.addEventListener('submit',async event=>{event.preventDefault();const form=event.target,button=form.querySelector('button'),status=form.querySelector('[role=status]');if(this.busy)return;this.busy=true;button.disabled=true;button.setAttribute('aria-busy','true');button.firstElementChild.textContent=button.dataset.loading;status.textContent='';const data=new FormData(form),drawer=document.querySelector('cart-drawer');if(this.dataset.context==='drawer'&&drawer?.getSectionsToRender){data.append('sections',drawer.getSectionsToRender().map(s=>s.id).join(','));data.append('sections_url',location.pathname);}try{const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'},body:data});const result=await response.json();if(!response.ok||result.status)throw new Error(result.description||status.dataset.error);if(this.dataset.context==='drawer'&&drawer?.renderContents&&result.sections){drawer.renderContents(result);const checkout=drawer.querySelector('[name="checkout"]');if(typeof trapFocus==='function')trapFocus(drawer.querySelector('.drawer__inner'),checkout);else checkout?.focus();}else location.assign(this.dataset.cartUrl);}catch(error){status.textContent=error.message||status.dataset.error;button.disabled=false;button.removeAttribute('aria-busy');button.firstElementChild.textContent=button.dataset.idle;this.busy=false;}},options);}
 disconnectedCallback(){this.abort?.abort();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["avora-customer-videos"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('avora-customer-videos'))customElements.define('avora-customer-videos',class extends HTMLElement{
connectedCallback(){
 this.abort=new AbortController();const signal=this.abort.signal,track=this.querySelector('.av-user-video-track');if(!track)return;
 this.setAttribute('data-ready','');const footer=this.querySelector('.av-user-video-footer'),bar=this.querySelector('.av-user-video-progress'),status=this.querySelector('[role=status]');
 const sync=()=>{const max=track.scrollWidth-track.clientWidth;footer.hidden=max<2;bar.style.setProperty('--video-visible',Math.min(100,track.clientWidth/track.scrollWidth*100)+'%');bar.style.setProperty('--video-position',Math.max(0,track.scrollLeft)/track.scrollWidth*100+'%');this.querySelectorAll('[data-direction]').forEach(button=>button.disabled=Number(button.dataset.direction)<0?track.scrollLeft<2:track.scrollLeft>=max-2);};
 const move=direction=>{const card=track.querySelector('.av-user-video-card');const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||0);track.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
 this.querySelectorAll('[data-play]').forEach(button=>{button.hidden=false;button.parentElement.querySelector('video').controls=false;});
 this.addEventListener('click',async event=>{const direction=event.target.closest('[data-direction]');if(direction){move(Number(direction.dataset.direction));return;}const button=event.target.closest('[data-play]');if(!button)return;const video=button.parentElement.querySelector('video');status.textContent='';this.activeVideo=video;this.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();});button.disabled=true;try{video.controls=true;await video.play();button.hidden=true;video.focus();}catch(error){if(error.name!=='AbortError'&&this.activeVideo===video){video.controls=true;button.hidden=true;status.textContent=status.dataset.error;}}finally{button.disabled=false;}},{signal});
 track.addEventListener('keydown',event=>{if(event.target!==track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}},{signal});
 this.addEventListener('play',event=>{if(event.target.tagName!=='VIDEO')return;this.querySelectorAll('video').forEach(video=>{if(video!==event.target)video.pause();});event.target.parentElement.querySelector('[data-play]').hidden=true;},{capture:true,signal});
 const showCover=event=>{if(event.target.tagName==='VIDEO')event.target.parentElement.querySelector('[data-play]').hidden=false;};this.addEventListener('pause',showCover,{capture:true,signal});this.addEventListener('ended',showCover,{capture:true,signal});
 track.addEventListener('scroll',sync,{passive:true,signal});this.resize=new ResizeObserver(sync);this.resize.observe(track);this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)entry.target.pause();}),{threshold:.1});this.querySelectorAll('video').forEach(video=>this.observer.observe(video));sync();
}
disconnectedCallback(){this.querySelectorAll('video').forEach(video=>video.pause());this.abort?.abort();this.resize?.disconnect();this.observer?.disconnect();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["avora-premium-addon"] && !Shopify.designMode) return;
  try {
    /* Remove only the duplicate AOV Carry recommendation; never change an offer or cart form. */
if (!customElements.get('avora-addon-deduplicate')) {
  customElements.define('avora-addon-deduplicate', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.product__info-container');
      if (!this.scope || !this.scope.querySelector('avora-premium-addon,avora-full-set[data-mode="addon"]')) return;
      this.pending = new Set([this.scope]);
      this.frame = 0;
      const labels = new Set(['lisää kaulanauha', 'frequently bought together']);
      const protectedContent = 'product-form,form[data-type="add-to-cart-form"],.product-form__submit,variant-selects,.product-form__quantity,.Avada-Bundle-Offer__Volume,.Avada-Volume__Item,avora-premium-addon,avora-full-set,.product__title,.product__text,[id^="price-"],.av-product-delivery,avora-customer-videos,.product__accordion,.jdgm-widget';
      const appContent = '[class*="AOV-"],[class*="Avada-"]';
      const hideDuplicate = heading => {
        let widget = null;
        for (let node = heading.parentElement; node && node !== this.scope; node = node.parentElement) {
          if (node.matches(protectedContent) || node.querySelector(protectedContent)) break;
          if (/avora\s+carry/i.test(node.textContent) &&
              (node.matches(appContent) || node.querySelector(appContent))) widget = node;
        }
        if (widget && !widget.hasAttribute('data-avora-aov-duplicate')) {
          widget.setAttribute('data-avora-aov-duplicate', '');
        }
      };
      const inspect = root => {
        if (!root.isConnected || !this.scope.contains(root)) return;
        const candidates = [root, ...root.querySelectorAll('h2,h3,h4,p,span,div')];
        for (const node of candidates) {
          if (node.closest('avora-premium-addon,avora-full-set,[data-avora-aov-duplicate]')) continue;
          if (node.childElementCount > 1) continue;
          const label = node.textContent.trim().replace(/\s+/g, ' ').toLocaleLowerCase('fi');
          if (labels.has(label)) hideDuplicate(node);
        }
      };
      this.flush = () => {
        this.frame = 0;
        const roots = [...this.pending];
        this.pending.clear();
        if (!this.scope.querySelector('avora-premium-addon,avora-full-set[data-mode="addon"]')) return;
        for (const root of roots) {
          if (!roots.some(other => other !== root && other.contains(root))) inspect(root);
        }
      };
      this.observer = new MutationObserver(records => {
        for (const record of records) {
          if (record.type === 'characterData') {
            if (record.target.parentElement) this.pending.add(record.target.parentElement);
          } else {
            for (const node of record.addedNodes) {
              const candidate = node.nodeType === 1 ? node : node.parentElement;
              if (candidate) this.pending.add(candidate);
            }
          }
        }
        if (this.pending.size && !this.frame) this.frame = requestAnimationFrame(this.flush);
      });
      this.observer.observe(this.scope, {childList: true, subtree: true, characterData: true});
      this.flush();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.pending?.clear();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
